import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import common from '@common';
import Rollbar from 'rollbar';

import offlineConfig from '@redux-offline/redux-offline/lib/defaults';

const {
  image: { getImageSourceInfo, isImageFile },
  storage: { getCompanyId, getUserId },
  tokenUtils: { getAuthToken },
} = common.utils;

axios.defaults.baseURL = process.env.API_BASE_URL;

const myOfflineConfig = {
  ...offlineConfig,
  discard: (error, action) => {
    const axiosStatus = _.get(error, 'response.status');
    if (axiosStatus && axiosStatus >= 400 && axiosStatus < 500) {
      return true;
    }

    if (!error) {
      Rollbar.warning('Problems with getting error info for action', { action });
    }

    if (_.get(error, 'timeout_error') || _.get(error, 'error')) {
      return false;
    }

    const status = _.get(error, 'status');
    if (status && status >= 400 && status < 500) {
      return true;
    }
    return false;
  },
  effect: async effect => {
    if (effect && effect.length === 2) {
      return new Promise((resolveEffect, rejectEffect) => {
        effect(resolveEffect, rejectEffect);
      });
    }
    if (effect && effect.url && (effect.data || effect.formData)) {
      const token = getAuthToken();
      const taskToken = getAuthToken('task');

      const headers = {
        'Content-Type': 'application/json',
        'Breezeway-Platform': 'web',
        'Breezeway-Version': process.env.PACKAGE_VERSION,
      };

      const userId = getUserId();
      const companyId = getCompanyId();
      if (userId) headers.BreezewayUID = userId;
      if (companyId) headers.BreezewayCID = companyId;

      if (token) {
        headers.Authorization = `JWT ${token}`;
      }

      if (taskToken) {
        headers.TaskToken = taskToken;
      }

      let offset = {};
      if (effect.originalDispatchTime) {
        offset = { offset: moment.utc().diff(effect.originalDispatchTime, 'seconds') };
      }
      if (effect.formData) {
        const data = new FormData();
        _.each(Object.keys(effect.formData), field => {
          data.append(field, effect.formData[field]);
        });
        if (effect.originalDispatchTime) {
          data.append('offset', offset.offset);
        }

        const file = _.get(effect, 'formData.file');
        const isImage = isImageFile(file);
        if (isImage) {
          return getImageSourceInfo(file).then(info => {
            _.forEach(info, (value, key) => {
              data.append(key, value);
            });
            return axios({
              data,
              method: effect.method,
              url: effect.url,
              headers,
            });
          });
        }

        return axios({
          data,
          method: effect.method,
          url: effect.url,
          headers,
        });
      }

      return axios({
        data: { ...effect.data, ...offset },
        method: effect.method,
        url: effect.url,
        headers,
      });
    }
    return new Promise(resolve => resolve());
  },
  persist: false,
  retry: (_2, retries) => (retries % 6 === 5 ? 15000 : 5000),
};

export default myOfflineConfig;
